import { render, staticRenderFns } from "./ZisPayment.vue?vue&type=template&id=2d8e79d9"
import script from "./ZisPayment.vue?vue&type=script&lang=js"
export * from "./ZisPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports